import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Youtube } from 'lucide-react'
import './DocumentPage.css'

const VideoTutorials = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>Video Tutorials</h1>
        <p className="lead">
          Watch comprehensive video tutorials to master the Variable Modding System quickly.
        </p>

        <h2>Available Tutorials</h2>
        <p>
          Our video tutorial series covers everything from basic setup to advanced techniques.
          Each tutorial includes practical examples and best practices.
        </p>

        <div style={{ marginTop: '2rem', display: 'grid', gap: '1.5rem' }}>
          <Link to="/video-tutorials/getting-started" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            padding: '1.5rem',
            backgroundColor: 'var(--color-bg-elevated)',
            borderRadius: '8px',
            textDecoration: 'none',
            border: '1px solid var(--color-border)',
            transition: 'all 0.2s'
          }}>
            <Youtube size={32} style={{ color: 'var(--color-brand)' }} />
            <div>
              <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.2rem' }}>Getting Started Tutorial</h3>
              <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>
                Learn the basics of installation, setup, and creating your first variable configuration.
              </p>
            </div>
          </Link>

          <Link to="/video-tutorials/example-fragments" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            padding: '1.5rem',
            backgroundColor: 'var(--color-bg-elevated)',
            borderRadius: '8px',
            textDecoration: 'none',
            border: '1px solid var(--color-border)',
            transition: 'all 0.2s'
          }}>
            <Youtube size={32} style={{ color: 'var(--color-brand)' }} />
            <div>
              <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.2rem' }}>Example: Using Fragments</h3>
              <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>
                A practical example showing how to use the Variable Modding System with game fragments.
              </p>
            </div>
          </Link>
        </div>

        <h2>What You'll Learn</h2>
        <ul>
          <li>Installation and initial configuration</li>
          <li>Creating and managing CSV data tables</li>
          <li>Testing in editor and packaged builds</li>
          <li>Advanced integration techniques</li>
          <li>Best practices and optimization tips</li>
        </ul>

        <h2>Video Format</h2>
        <p>
          All tutorials are hosted on YouTube and include:
        </p>
        <ul>
          <li>High-quality screen recordings</li>
          <li>Clear audio narration</li>
          <li>Step-by-step walkthroughs</li>
          <li>Downloadable example projects</li>
          <li>Timestamps for easy navigation</li>
        </ul>

        <h2>Need More Help?</h2>
        <p>
          If you have questions after watching the tutorials, join our{' '}
          <a href="https://discord.gg/WbbBfkNaxt" target="_blank" rel="noopener noreferrer">
            Discord community
          </a>{' '}
          for support.
        </p>
      </div>
    </div>
  )
}

export default VideoTutorials
